module.exports = __webpack_public_path__ + "img/graphic.f6c75a0e.svg";